import { Box, Typography } from "@mui/material";

type Props = {
  count: number;
};

const UnreadMessageCount = ({ count }: Props) => {
  // if zero
  if (!count) return null;

  return (
    <Box
      bgcolor={(theme) => theme.palette.primary.light}
      display="flex"
      alignItems="center"
      justifyContent="center"
      minWidth="18px"
      minHeight="18px"
      maxWidth="18px"
      maxHeight="18px"
      borderRadius="100%"
      color="#fff"
    >
      <Typography fontSize="12px" fontWeight={600}>
        {count}
      </Typography>
    </Box>
  );
};

export default UnreadMessageCount;
